import { CdkPortal, PortalModule } from '@angular/cdk/portal';

import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  forwardRef,
  input,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Tab } from './tab';
import { TabTitleDirective } from './tab-title/tab-title.directive';

@Component({
  selector: 'soft-tab',
  imports: [PortalModule],
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.css'],
  providers: [{ provide: Tab, useExisting: forwardRef(() => TabComponent), multi: true }],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'class()',
  },
})
export class TabComponent extends Tab {
  @Input() title?: string | null | undefined;

  readonly icon = input<string | null | undefined>(undefined);
  readonly badge = input<number | null | undefined>(undefined);
  readonly badgeClass = input<string | null | undefined>(undefined);

  @ContentChild(TabTitleDirective) templateTitle?: TabTitleDirective;
  @ViewChild(CdkPortal, { static: true }) content?: CdkPortal;

  @Output() activate = new EventEmitter<any>();
  @Output() deactivate = new EventEmitter<any>();

  class = input<string | null>(null);

  constructor() {
    super();
  }
}
